// Sales & Packages persistence for KRYOTEKS
const SALES_KEY = 'hbc_sales_v1';
const PACKAGES_KEY = 'hbc_packages_v1';

function safeLoad(key) {
  try {
    const raw = localStorage.getItem(key);
    if (!raw) return [];
    const parsed = JSON.parse(raw);
    return Array.isArray(parsed) ? parsed : [];
  } catch {
    return [];
  }
}

export function loadSales() {
  return safeLoad(SALES_KEY);
}

export function saveSale(sale) {
  const list = loadSales();
  list.unshift(sale);
  localStorage.setItem(SALES_KEY, JSON.stringify(list));
  return list;
}

export function deleteSale(id) {
  const list = loadSales().filter((s) => s.id !== id);
  localStorage.setItem(SALES_KEY, JSON.stringify(list));
  return list;
}

export function loadPackages() {
  return safeLoad(PACKAGES_KEY);
}

export function savePackages(list) {
  localStorage.setItem(PACKAGES_KEY, JSON.stringify(list));
}

export function upsertPackage(pkg) {
  const list = loadPackages();
  const idx = list.findIndex((p) => p.id === pkg.id);
  if (idx >= 0) list[idx] = pkg;
  else list.unshift(pkg);
  savePackages(list);
  return list;
}

export function redeemPackageSession(pkgId) {
  const list = loadPackages();
  const idx = list.findIndex((p) => p.id === pkgId);
  if (idx < 0) return { list, pkg: null };
  const pkg = list[idx];
  if (pkg.sessionsRemaining <= 0) return { list, pkg };
  const updated = {
    ...pkg,
    sessionsRemaining: pkg.sessionsRemaining - 1,
    redemptions: [
      ...(pkg.redemptions || []),
      { at: new Date().toISOString() },
    ],
  };
  list[idx] = updated;
  savePackages(list);
  return { list, pkg: updated };
}

export function deletePackage(id) {
  const list = loadPackages().filter((p) => p.id !== id);
  savePackages(list);
  return list;
}

export function getSalesForClient(clientId) {
  if (!clientId) return [];
  return loadSales().filter((s) => s.clientId === clientId);
}

export function getPackagesForClient(clientId) {
  if (!clientId) return [];
  return loadPackages().filter((p) => p.clientId === clientId);
}

export function generateId(prefix = 'x') {
  return `${prefix}_${Date.now()}_${Math.random().toString(36).slice(2, 9)}`;
}
